import {Component, InjectionToken} from "@angular/core";
import {EDIT_CONTROL_LABEL_CONTEXT} from "./abstract-edit-control.component";

export const EDIT_CONTROL_LABEL_CONTEXT_VALUE = new InjectionToken<string>("EDIT_CONTROL_LABEL_CONTEXT_VALUE");

@Component({
    selector: "wbo-edit-control-label-context",
    template: "<ng-content></ng-content>",
    providers: [
        {provide: EDIT_CONTROL_LABEL_CONTEXT, useExisting: EDIT_CONTROL_LABEL_CONTEXT_VALUE},
    ]
})
export class EditControlLabelContextComponent {
}
